import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl, UrlParams } from 'framework/routing';

export const SEND_EMAIL_PATH = '/send-email';

export const useSendEmailId = () => {
  const urlParams: UrlParams = useParams<Dictionary<string>>();

  return urlParams.id!;
};

export const useSendEmailUrl = () => {
  return useEntityUrl({
    baseLink: SEND_EMAIL_PATH,
  });
};

export const useSendEmailRoute = () => {
  return createRoute({ listRoute: SEND_EMAIL_PATH });
};
